export default "__VITE_ASSET__c19f684a__"